export default __webpack_public_path__ + "02f747c1fcdb53c32b0ed468066e5826.svg";